<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(handleEdit)">
        <div class="">
          <div class="">
            <p class="input-title textcolor">Type of Art</p>
            <b-form-select
              v-model="art"
              placeholder="Select Artwork"
              class="md:border-0 lg:border-0 custipshadow"
              name="city"
            >
              <b-form-select-option :value="null" class="textcolor"
                >Please select an option</b-form-select-option
              >
              <b-form-select-option value="Poetry" class="textcolor"
                >Poetry</b-form-select-option
              >
              <b-form-select-option value="Photo" class="textcolor"
                >Photo</b-form-select-option
              >
              <b-form-select-option value="Video" class="textcolor"
                >Video</b-form-select-option
              >
              <b-form-select-option value="Prose" class="textcolor"
                >Prose</b-form-select-option
              >
            </b-form-select>
          </div>

          <div
            class="lg:mt-6 md:mt-6 mt-6"
            v-if="art === 'Photo' || art === 'Poetry' || art === 'Prose'"
          >
            <p class="input-title textcolor">Photo</p>
            <!-- <el-upload
              class="upload-demo"
              :auto-upload="false"
              action="#"
              list-type="picture-card"
              accept="image/*"
              :file-list="fileListImage"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :before-upload="beforeUpload"
              :limit="1"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload> -->
            <div class="grid grid-cols-2 gap-6">
              <div
                class="relative cursor-pointer bg-fa dash-primary w-full h-40 rounded-lg overflow-hidden flex items-center justify-center"
              >
                <div v-if="!imagePreview">
                  <p class="fsize14 text-center text-gray">Upload Here</p>
                </div>
                <input
                  type="file"
                  class="uploads absolute top-0 left-0 w-full h-40 opacity-0 cursor-pointer"
                  accept="image/*"
                  @change="handleImageUpload"
                />
              </div>

              <div v-if="imagePreview" class="relative">
                <img
                  :src="imagePreview"
                  alt="Uploaded"
                  class="w-full h-40 object-cover rounded-lg"
                />
                <div class="absolute top-0 right-0 m-1">
                  <div
                    class="w-6 h-6 rounded-full flex items-center justify-center bg-white cursor-pointer"
                    @click="removeImage"
                  >
                    <feather-icon
                      icon="XIcon"
                      svgClasses="w-4 h-4"
                      class="flex text-primary"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="art === 'Video' || art === 'Poetry' || art === 'Prose'"
            class="pt-3"
          >
            <div>
              <p class="input-title textcolor">Video</p>
              <el-upload
                class="upload-demo"
                :auto-upload="false"
                action="#"
                accept="video/mp4,video/x-m4v,video/*"
                :file-list="fileListVideo"
                :on-change="handleVideoChange"
                :on-remove="handleVideoRemove"
              >
                <b-button
                  variant="primary"
                  class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                  >Upload Video</b-button
                >
              </el-upload>
            </div>
            <div class="pt-3">OR</div>
            <div class="pt-3">
              <p class="input-title textcolor">Video URL</p>
              <base-input
                v-model="videoUrl"
                placeholder="Enter your Video Url"
                class="md:border-0 lg:border-0 custipshadow"
                name="videoUrl"
                :rules="{}"
              ></base-input>
            </div>
          </div>

          <div class="mt-2">
            <p class="input-title textcolor">Name</p>
            <base-input
              v-model="firstName"
              placeholder="Enter your First Name"
              class="md:border-0 lg:border-0 custipshadow"
              name="First Name"
              :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
              @input="
                firstName = firstName
                  .replace(/[^A-Za-z\s]/g, '')
                  .replace(/\s{2,}/g, ' ')
              "
            ></base-input>
          </div>
          <div class="">
            <p class="input-title textcolor">Last Name</p>
            <base-input
              v-model="lastName"
              placeholder="Enter your Last Name"
              class="md:border-0 lg:border-0 custipshadow"
              name="Last Name"
              :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
              @input="
                lastName = lastName
                  .replace(/[^A-Za-z\s]/g, '')
                  .replace(/\s{2,}/g, ' ')
              "
            ></base-input>
          </div>

          <div class="">
            <p class="input-title textcolor">Mobile No.</p>
            <base-input
              v-model="mobile"
              placeholder="Enter your Mobile No."
              class="md:border-0 lg:border-0 custipshadow"
              name="Mobile No."
              :rules="{ required: true, regex: /^[0-9]{10}$/ }"
              @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
            ></base-input>
          </div>

          <div class="">
            <p class="input-title textcolor">Email Address</p>
            <base-input
              v-model="email"
              placeholder="Enter your EmailID"
              class="md:border-0 lg:border-0 custipshadow"
              name="Email"
              :rules="{ required: true, email: true }"
              @input="email = email.toLowerCase()"
            ></base-input>
          </div>

          <div class="pt-3" v-if="art === 'Poetry'">
            <p class="input-title textcolor">Poetry Heading</p>
            <base-input
              v-model="poetryHeading"
              placeholder="Enter your poetry heading"
              class="md:border-0 lg:border-0 custipshadow"
              name="Poetry Heading"
              :rules="{ required: true }"
            ></base-input>
          </div>

          <div class="md:mb-0 lg:mb-0 mb-9">
            <p class="input-title textcolor">Message</p>

            <quill-editor
              v-model="message"
              :options="editorOption"
              class="quill-h200px my-2 bg-white"
            />
          </div>

          <div class="flex justify-center">
            <b-button type="submit" variant="primary">Save</b-button>
          </div>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import FileUploader from "@/components/FileUploader.vue";
import { Upload } from "element-ui";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    FileUploader,
    quillEditor,
    [Upload.name]: Upload,
  },
  props: {
    // getShareWork: {
    //   type: Function,
    // },
    // editModal: {
    //   type: Boolean,
    // },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      message: "",
      videoUrl: "",
      poetryHeading: "",
      selectedFile: null,
      imagePreview: null,
      video: null,
      images: [],
      art: null,
      artWorkPermission: false,
      editorOption: {
        theme: "snow",
      },

      fileListVideo: [],
      fileListImage: [],
    };
  },
  watch: {
    editData: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getUrl(data) {
      return `${this.$imageURL}/${data}`;
    },

    //edit
    beforeUpload(file) {
      if (this.fileListImage.length >= 1) {
        this.$message.warning("You can only upload one image");
        return false;
      }
      return true;
    },
    handleVideoChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      }
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.video = fileList[0].raw;
    },
    handleVideoRemove(file, fileList) {
      const index = fileList.indexOf(file);
      fileList.splice(index, 1);
      this.video = null;
    },
    // handleImageChange(file, fileList) {
    //   let mByte = 5 * 1048576;
    //   if (file.size > mByte) {
    //     this.$swal.fire({
    //       title: "File size exceeds the allowed limit!",
    //       html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
    //       confirmButtonText: "Okay",
    //       icon: "warning",
    //       confirmButtonColor: "#830c81",
    //       showCancelButton: false,
    //     });
    //     fileList.pop();
    //     return;
    //   } else {
    //     this.images = fileList.map((data) => data.raw);
    //   }
    // },
    // handleImageRemove(file, fileList) {
    //   // console.log(file);
    //   fileList = fileList.filter((item) => item.uid !== file.uid);
    //   this.images = fileList.map((data) => data.raw);
    //   // console.log(fileList);
    //   // console.log(this.images);
    // },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const mByte = 5 * 1048576; // 5 MB
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });

        const fileInput = document.querySelector(".uploads");
        if (fileInput) fileInput.value = "";

        return;
      }
      this.selectedFile = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imagePreview = reader.result;
        this.fileListImage = [
          {
            name: file.name,
            url: reader.result,
            raw: file,
          },
        ];
      };
    },

    removeImage() {
      this.selectedFile = null;
      this.imagePreview = null;

      const fileInput = document.querySelector(".uploads");
      if (fileInput) {
        fileInput.value = "";
      }
    },
    resetForm() {
      this.art = null;
      // this.city = "";
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.mobile = "";
      this.message = "";
      this.videoUrl = "";
      this.video = null;
      this.images = [];
      this.artWorkPermission = false;
    },
    async handleEdit() {
      if (this.art === null) {
        this.$swal.fire({
          text: `Please Select Art!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      if (this.art === "Poetry" && this.message === "") {
        this.$swal.fire({
          text: `Please Enter Message!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }

      let FormData = require("form-data");
      let data = new FormData();
      data.append("firstName", this.firstName);
      if (this.lastName) data.append("lastName", this.lastName);
      if (this.email) data.append("email", this.email);
      if (this.mobile) data.append("mobile", this.mobile);
      data.append("shareWorkId", this.editData._id);
      data.append("art", this.art);
      data.append("message", this.message);
      data.append("userId", this.user._id);
      data.append("isAdmin", JSON.stringify(true));
      data.append("status", "Approved");
      if (this.video) {
        data.append("video", this.video);
      } else {
        data.append("video", "");
      }

      if (this.videoUrl) {
        data.append("videoUrl", this.videoUrl);
      } else {
        data.append("videoUrl", "");
      }

      if (this.poetryHeading) {
        data.append("poetryHeading", this.poetryHeading);
      } else {
        data.append("poetryHeading", "");
      }
      if (this.selectedFile) {
        data.append("images", this.selectedFile); // Upload new image
      } else if (this.imagePreview) {
        data.append("images", this.fileListImage[0].raw); // Keep existing image
      } else {
        data.append("images", ""); // Send empty if no image
      }

      data.append("artWorkPermission", true);

      // console.log(this.images);

      let loader = this.$loading();

      if (this.art === "Video" && this.video === null && this.videoUrl === "") {
        this.$swal.fire({
          text: "Please Select Video or Video Url",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      if (this.art === "Photo" && !this.selectedFile && !this.imagePreview) {
        this.$swal.fire({
          text: "Please Select image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const shareWorkData = await this.$store.dispatch(
          "hoc/updateSharework",
          data
        );
        if (shareWorkData.code == 200) {
          // this.$router.push({ name: "blogs" });
          this.closeModal();
          this.getShareWork();
          this.$swal.fire({
            text: "ArtWork Updated Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.resetForm();
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
          console.log(error);
        }
      }
    },
    closeModal() {
      // console.log("closeModal");
      this.$emit("closeModal");
    },
    async init() {
      if (!this.editData || !Object.keys(this.editData).length) {
        return;
      }
      this.firstName = this.editData.firstName;
      this.lastName = this.editData.lastName;
      this.email = this.editData.email;
      this.mobile = this.editData.mobile;
      this.message = this.editData.message;
      this.art = this.editData.art;
      this.videoUrl = this.editData.videoUrl ? this.editData.videoUrl : "";
      this.video = this.editData.video ? this.editData.video : null;
      this.fileListVideo = this.editData.video
        ? [{ name: "video.mp4", url: this.getUrl(this.editData.video) }]
        : [];
      const existingImage = Array.isArray(this.editData.images)
        ? this.editData.images[0]
        : this.editData.images;
      this.imagePreview = existingImage ? this.getUrl(existingImage) : null;
      this.poetryHeading = this.editData.poetryHeading
        ? this.editData.poetryHeading
        : "";
      if (existingImage) {
        const imageFile = await this.getImageMetadata(this.getUrl(existingImage));
        this.fileListImage = [
          {
            name: "image1",
            url: this.imagePreview,
            raw: imageFile,
          },
        ];
      } else {
        this.fileListImage = [];
      }
      this.artWorkPermission = this.editData.artWorkPermission;
    },
    getShareWork() {
      // console.log("getShareWork");
      this.$emit("getShareWork");
    },
    async getImageMetadata(imageUrl) {
      let raw = await fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          // this.convertBlobToImage(blob);
          // const reader = new FileReader();
          // reader.onloadend = function () {
          // const arrayBuffer = reader.result;
          // const dataView = new DataView(arrayBuffer);
          //const metadata = extractImageMetadata(dataView);
          // console.log(dataView);
          // console.log(blob);
          const file = new File([blob], "media", { type: blob.type });
          // console.log(file);
          return file;
          // };
          // reader.readAsArrayBuffer(blob);
        })
        .catch((error) => {
          console.error("Error fetching the image:", error);
        });
      // console.log(raw);
      return raw;
    },
    // convertBlobToImage(blob) {
    //   const img = document.createElement("img");
    //   img.src = URL.createObjectURL(blob);
    //   console.log(img);
    //   // Append the image to the DOM or use it as needed
    //   // document.getElementById("allMetaDataSpan").appendChild(img);
    // },
  },
  computed: {
    ...mapState("hoc", { shareWork: "shareWork" }),
    ...mapState("auth", { user: "user" }),
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.textcolor {
  color: #777777 !important;
}
</style>
